import { z } from "zod";

export const landingSchema = () => {
  return z.object({
    slug: z.string().min(1),
    agreement: z.number().min(1),
    email: z.string().email().optional().nullable(),
    type: z.string().min(1),
    phone_image: z.any().optional().nullable(),
    welcome_text: z.string().optional().nullable(),
    welcome_text_color: z.string().optional().nullable(),
    metadata: z.object({
      buttonRegisterName: z.string().optional().nullable(),
      subscription: z.boolean().default(true),
      profileEdit: z.boolean().default(true),
      removePlan: z.boolean().default(false),
      buttonCpfName: z.string().optional().nullable(),
      nomeLanding: z.string().optional().nullable(),
      benefitsName: z.string().optional().nullable(),
      moduleExternalCode: z.boolean().optional().nullable(),
      buttonSubscriptionExternalCode: z.string().optional().nullable(),
      maskSubscriptionExternalCode: z.string().optional().nullable(),
      labelSubscriptionExternalCode: z.string().optional().nullable(),
    }),
  });
};

export type LandingFormValues = z.infer<ReturnType<typeof landingSchema>>;
